import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.dom.addClass
import kotlinx.dom.clear
import kotlinx.dom.removeClass
import model.Empresa
import model.Logon
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.attributes.disabled
import org.jetbrains.compose.web.attributes.type
import org.jetbrains.compose.web.renderComposable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.*
import utils.*
import utils.ff.Companion.goFUNCIONARIO
import utils.ff.Companion.gsAdmRet
import utils.ff.Companion.gsNavePage
import utils.ff.Companion.gsVersao
import utils.ff.Companion.println0
import views.coletor.principalCOL
import views.componentes.ffAudio
import views.password.password
import views.representante.principalREP

var lbErro: HTMLSpanElement? = null //document.getElementById("lbErro") as HTMLSpanElement
var lbTitulo: HTMLSpanElement? = null
var fontSmall = 14.px
var div1Hei = 60.px
var bt1Hei = 33.px


object AppStylesheet : StyleSheet() {
    val container by style { // container is a class
        display(DisplayStyle.Flex)
        padding(20.px)

        // custom property (or not supported out of a box)
        property("font-family", "Arial, Helvetica, sans-serif")
        //property("form-group")
    }
}

fun main() {

    println("carregou a index.html ${document.documentElement!!.getAttribute("value")}")
    val teste = js("navigator.userAgent")
    println(teste)
    var sTeste = ""
    //val sUrl = js("document.URL").toString()
    sTeste = ff.ffPegaCampo(document.documentElement!!.getAttribute("value")!!, "obj=")
    //println0(sTeste)

    val htmlDivCabec = document.getElementById("htmlDivCabec") as HTMLDivElement
    htmlDivCabec.clear()

    renderComposable(rootElementId = "htmlDivCabec") {
        cabecalho()
    }
    lbErro = document.getElementById("lbErro") as HTMLSpanElement
    lbTitulo = document.getElementById("lbTitulo") as HTMLSpanElement
    ffEnter2Tab(13)

    if (sTeste.length < 30) {
        if (!sTeste.equals(""))
            gsAdmRet = "AdmRet" + sTeste.ffPegaCampoAte("$", "%22")
        //println0(gsAdmRet)
        password().show("main")
    } else {
        //val obj = //JSON.parse<Logon.AdmRet>(sTeste)
        sTeste = sTeste.replace("%22", "\"")
        val obj = Logon.AdmRet().construtorLista(sTeste).get(0)

        //println0(obj)
        ff.gsToken = obj.CHAVE
        ff.giEmpresa = obj.EMPRESA2.ffVsi()

        ff.goFUNCIONARIO.FUNC_EMPRESA = ff.giEmpresa
        ff.goFUNCIONARIO.ID_FUNCIONARIO = obj.ID_FUNCIONARIO
        ff.goFUNCIONARIO.FUNC_NOME = obj.FUNC_NOME
        ff.goFUNCIONARIO.FUNC_FUNCAO = obj.FUNC_FUNCAO
        ff.goFUNCIONARIO.FUNC_LOGON = obj.LOGON
        ff.goFUNCIONARIO.FUNC_TRANSPDOM00 = obj.FUNC_TRANSPDOM00.replace("!", "/")

        ff.gsDom1 = ff.goFUNCIONARIO.FUNC_TRANSPDOM00

        ff.gsAdmRet = obj.OO_ADMRET
        //giEmpresa = obj.EMPRESA.ID_EMPRESA

        //ff.println0(obj.EMPRESA!!)

        //val sTeste: String = JSON.stringify(obj.EMPRESA)
        //println0(sTeste)
        ff.goEMPRESA = Empresa().construtorLista(JSON.stringify(obj.EMPRESA)).get(0)
        ff.gsDesenvolvedor = obj.GSDESENVOLVEDOR
        ff.println0("objeto empresa gsDesenvolvedor=${ff.gsDesenvolvedor}")
        println0(ff.goEMPRESA)
        println(ff.goEMPRESA.EMP_URLPRO00)
        println(ff.gsDom1)

        ff.gsCamView = obj.GSCANVIEW

        println("deveria seguir para o coletor999")
        println(ff.goEMPRESA)
        println(ff.goFUNCIONARIO)
        if (ff.goFUNCIONARIO.FUNC_FUNCAO.equals("F"))
            principalCOL().show()
        else if (ff.goFUNCIONARIO.FUNC_FUNCAO.equals("E"))
            principalREP().show()
        else
            ffMsgAvisoc(
                "Password", "Função ${ff.goFUNCIONARIO.FUNC_FUNCAO} do funcionário ${ff.goFUNCIONARIO.ID_FUNCIONARIO}" +
                        " da empresa ${ff.goFUNCIONARIO.FUNC_EMPRESA}, não aceita no coletor"
            )

    }
}

@Composable
fun cabecalho() {

    Div(attrs = { id("formMenu"); classes("form-group", "navbar-dark", "bg-dark") }) {


        Nav {

            Span({
                id("lbErro"); classes("dlg-select", "dlg-font9"); style { display(DisplayStyle("block")) }
            })

            //Div()
            Div(attrs = { classes("navbar", "navbar-dark", "bg-dark"); style { height(60.px) } }) {
                H3({
                    style { color(Color.green) };
                    classes("dlg-titulo");
                    //onClick { js("window.location.reload(true)") }
                    onClick {
                        //var sTeste = document.documentElement!!.getAttribute("value") + ""
                        var sTeste = window.location.toString()
                        sTeste = sTeste.replace("/$gsVersao/", "/000/")
                        println(gsVersao)
                        println(sTeste)
                        if (goFUNCIONARIO.FUNC_LOGON == "Visitante22")
                            sTeste = "http://dlgestoque.ddns.net:8282/pro/000/web/index.html"
                        ffJavaScript("window.location='$sTeste';")
                    }
                }) {
                    Text("Dlógica")
                }

                Button(attrs = {
                    classes("btn", "btn-outline-success", "my-2", "my-sm-0", "dlg-font8")
                    id("btCabecVoltar")

                    onClick { _ ->
                        if (gsNavePage.contains("principalREP"))
                            principalREP().ffNavePage("")
                        else if (gsNavePage.contains("principalCOL"))
                            principalCOL().ffNavePage("")
                        else
                            main()
                    }
                }) {
                    Text("Voltar")
                }
            }

        }
        Div(attrs = { classes("dlg-cabec"); id("divTitulo") }) {
            Span(attrs = { classes("card-titulo"); id("lbTitulo") }) { }
        }

    }

}

@Composable
fun ffOption(_value: String, _text: String): Unit {
    return Option(value = _value) { Text(_text) }
}

@Composable
fun ffInputTeste(
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _classes: String = "",
    _width: Int = 100
): Unit {
    return TextInput(value = _valor.value,
        attrs = {
            classes("form-control")
            onInput {
                _valor.value = it.value
            }
            onChange { _valor.value = ffValidar(_valor.value, _tipoCampo, 10) }
        })
}

@Composable
fun ffInputKey(
    _text: String, _valor: MutableState<String>, _tipoCampo: String, _max: Int, _width: Int,
    //   _onclick: () -> Boolean,
//    _onkey: () -> Boolean,
    _key: MutableState<String>,
    _esp: Boolean = true, _id: String = ""
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    //return Div({ classes("dlg-margin-l"); style { width(_width.percent) } }) {
    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text") }
        Br()
        //Div({ classes("form-group", "input-group-append");  }) {
        TextInput(value = _valor.value,
            attrs = {
                //classes("form-control", "dlg-margin-l")
                if (!_id.equals(""))
                    id(_id)
                style { fontSize(fontSmall) }
                classes("form-control")
                onInput { _valor.value = it.value }
                onChange { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                onKeyDown { _key.value = it.getNormalizedKey() }
                if (_key.value.equals("disabled"))
                    disabled()
            })
        if (_esp)
            ffEspHorizontalMM(3)
        Br()
        //}
    }
}

@Composable
fun ffInputKeyNumber(
    _text: String, _valor: MutableState<String>, _tipoCampo: String, _max: Int, _width: Int,
    _key: MutableState<String>, _esp: Boolean = true, _id: String = ""
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    //return Div({ classes("dlg-margin-l"); style { width(_width.percent) } }) {
    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text") }
        Br()

        TextInput(value = _valor.value,
            attrs = {
                type(InputType.Text)
                if (!_id.equals(""))
                    id(_id)
                style { fontSize(fontSmall) }
                classes("form-control")
                onInput { _valor.value = it.value }
                //onChange { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                //    onClick { _1 -> _onclick.invoke() }
                onKeyDown { _key.value = it.getNormalizedKey() }
                if (_key.value.equals("disabled"))
                    disabled()
            })
        if (_esp)
            ffEspHorizontalMM(3)
        Br()

    }
}

@Composable
fun ffInputKey1(
    _text: String, _valor: MutableState<String>, _tipoCampo: String, _max: Int, _width: Int,
    _key: MutableState<String>,
    _esp: Boolean = true, _id: String = ""
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    //return Div({ classes("dlg-margin-l"); style { width(_width.percent) } }) {
    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text") }
        Br()
        //Div({ classes("form-group", "input-group-append");  }) {
        TextInput(value = _valor.value,
            attrs = {
                //classes("form-control", "dlg-margin-l")
                if (!_id.equals(""))
                    id(_id)
                classes("form-control")
                onInput {
                    _valor.value = it.value
                }
                onChange { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                //    onClick { _1 -> _onclick.invoke() }
                //onKeyDown { _key.value = it.getNormalizedKey() }
                onKeyDown { _key.value = it.getNormalizedKey() }
                if (_key.value.equals("disabled"))
                    disabled()
            })
        if (_esp)
            ffEspHorizontalMM(3)
//        Br()
    }
}


@Composable
fun ffInput(
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true,
    _id: String = ""
): Unit {

    var width = _width
    if (width == 0)
        width = 100

    var sKey = ""
    //return Div({ classes("dlg-margin-l"); style { width(_width.percent) } }) {
    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text".trim()) }
        Br()
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {
            TextInput(
                value = _valor.value,
                attrs = {
                    //classes("form-control", "dlg-margin-l")
                    if (!_id.equals(""))
                        id(_id)
                    style { (fontSize(fontSmall)) }
                    classes("form-control")
                    onInput {
                        _valor.value = it.value
                    }
                    onChange { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }
                    onKeyDown { sKey = it.getNormalizedKey() }
                    //onClick { _ -> _onclick }
                })
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}

@Composable
fun ffInputNumberAntigo(
    _text: String,
    _valor: MutableState<String>,
    _tipoCampo: String,
    _max: Int,
    _width: Int,
    _esp: Boolean = true,
    _id: String = ""
): Unit {

    var sKey = ""
    return Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
        Span { Text("$_text".trim()) }
        Br()
        Div({ classes("form-group", "input-group-append"); style { fontSize(fontSmall) } }) {
            Input(type = InputType.Number,
                attrs = {
                    if (!_id.equals("")) {
                        //println0("zuza14 identificação $_id")
                        id(_id)
                    }
                    value(_valor.value)
                    classes("form-control")
                    style { (textAlign("right")); fontSize(fontSmall) }
                    onInput { _valor.value = it.value.toString() }
                    onChange { _valor.value = ffValidar(_valor.value, _tipoCampo, _max) }

                    onKeyDown { sKey = it.getNormalizedKey() }
                }

            )
            if (_esp)
                ffEspHorizontalMM(3)
        }
    }
}


@Composable
fun ffCheckBoxInput(_span: String, _bValor: MutableState<Boolean>, _width: Int): Unit {

    return Div({ style { fontSize(fontSmall); width(_width.percent) } }) {
        CheckboxInput(_bValor.value,
            attrs = {
                //classes("form-control")
                onChange {
                    _bValor.value = it.value
                }
            })
        Text(" $_span")

    }
    //Span { Text(_span) }
}

@Composable
fun ffRadioInput(_span: String, _valor: MutableState<Int>, _value: Int, _width: Int): Unit {


    println0("vai colocar o ffRadioInput $_width")

    val lobj = _span.split(",")

    if (_width != 0) {
        return Div({ style { height(8.mm); width(_width.mm) } }) {
            RadioInput(checked = _valor.value == _value) {
                onChange { event -> if (event.value) _valor.value = _value }
            }
            Text(" $_span")
            //ffEspVertical(5)
        }

    } else {

        return Div({ style { height(8.mm) } }) {
            RadioInput(checked = _valor.value == _value) {
                onChange { event -> if (event.value) _valor.value = _value }
            }
            Text(" $_span")
            //ffEspVertical(5)
        }
    }
}

@Composable
fun ffButtonDiv(_text: String, _onclick: (Boolean) -> Unit, _width: Int): Unit {

    //return Div({ style { width(_width.percent); fontSize(small); paddingLeft(10.px) } }) {
    return Div({ classes("input-group-append"); style { width(_width.percent) } }) {

        Button(attrs = {
            classes("btn", "dlg-mobbt100")
            //classes("btn")
            //style { fontSize(fontSmall); height(bt1Hei); width(_width.percent); top(40.percent) }
            style { fontSize(fontSmall); height(bt1Hei); top(30.percent); left(10.px) }
            onKeyDown { _ -> _onclick.invoke(true) }
            onClick { _ -> _onclick.invoke(true) }
        }
        ) {
            Text(_text)
        }
    }
}

@Composable
fun ffButton0(_text: String, _onclick: (Boolean) -> Unit, _width: Int): Unit {

    //return Div({ style { width(_width.percent); fontSize(small); paddingLeft(10.px) } }) {
    return Button(attrs = {
        classes("btn", "dlg-mobbt100")
        //classes("btn")
        //style { fontSize(fontSmall); height(bt1Hei); width(_width.percent); top(40.percent) }
        //style { fontSize(fontSmall); height(bt1Hei); width(_width.percent); left(10.px) }
        if (_text.contains(":"))
            style { fontSize(fontSmall); height(bt1Hei); width(_width.px) }
        else
            style { fontSize(fontSmall); height(bt1Hei); width(_width.percent) }
        onKeyDown { _ -> _onclick.invoke(true) }
        onClick { _ -> _onclick.invoke(true) }
    }
    ) {
        Text(_text.replace(":", ""))
    }
}

@Composable
fun ffButtonRem(_text: String, _clicado: MutableState<String>, _onclick: () -> Boolean, _width: Int): Unit {

    //return Div({ style { width(_width.percent); fontSize(small) } }) {
    return Button(attrs = {
        classes("btn", "dlg-mobbt100")
        style { fontSize(fontSmall); height(bt1Hei); width(_width.percent); top(40.percent) }
        onKeyDown { _ -> _onclick.invoke() }
        onClick { _ -> _onclick.invoke() }
    }
    ) {
        Text(_text)
    }
}

@Composable
fun ffSpan(_text: String, _bold: Boolean = false, _width: Int = 0, _align: String = "left"): Unit {
//    if (_bold)
//        return Span({ style { fontSize(fontSmall); fontWeight("bold") } }) { Text(_text) }
//    else

    //val positi = Position.
    //Div({ style { width(_width.percent) } }) { Span { Text(_text) } }

//    if (_text.equals("Espaço")) {
//        Span() { Text("                            ") }
//    } else
//    if (_tipo.equals("") && _width != 0) {

    if (_width != 0) {
        if (_bold) {
            Span({ style { width(_width.percent); fontSize(fontSmall); fontWeight("bold"); textAlign(_align) } }) {
                Text(
                    _text
                )
            }
        } else {
            Span({ style { width(_width.percent); fontSize(fontSmall); textAlign(_align) } }) { Text(_text) }
        }
    } else {
        if (_bold) {
            Span({ style { fontSize(fontSmall); fontWeight("bold"); textAlign(_align) } }) { Text(_text) }
            Br()
        } else {
            Span({ style { fontSize(fontSmall); textAlign(_align) } }) { Text(_text) }
            Br()
        }
    }


//    else {
//        Div({ style { width(_width.percent); fontSize(fontSmall) } }) {
//            Text(_text)
//        }
//    }
}

fun ffMsgWindow(_text: String): Boolean {
    ffAudio().ffPlayBeep(false)
    return kotlinx.browser.window.confirm("$_text")
}

@Composable
fun ffEspHorizontalMM(_milimitros: Int): Unit {
    return Div({ style { width(_milimitros.mm) } })
}

@Composable
fun ffEspHorizontalP(_percent: Int): Unit {
    return Div({ style { width(_percent.percent) } })
}
//@Composable
//fun ffEspHorizontalMil(_milimitros: Int): Unit {
//    return Div({ style { width(_milimitros.mm) } })
//}

@Composable
fun ffEspVerticalMil(_milimitros: Int): Unit {
    return Div({ style { height(_milimitros.mm) } })
}

fun ffMsgAviso(sTexto: String, _audio: Boolean = false) {
    //println("vai imprimir no msg erro")
    ff.println0("@investigar ffMsgAviso = $sTexto")
    if (sTexto.ffCopy(1, 4).equals("Erro")) {
        ffMsgAvisoc("bg-danger", sTexto, _audio)
    } else {
        ffMsgAvisoc("bg-warning", sTexto, _audio)
    }
}

private fun ffMsgAvisoc(_classe: String, _texto: String, _audio: Boolean = false) {

    //ffAudio().ffPlayBeep(false)
    var sClasse = _classe
    if (sClasse.equals(""))
        sClasse = "bg-warning"
    if (lbErro != null) {
        lbErro!!.removeClass("bg-danger")
        lbErro!!.removeClass("bg-warning")
        if (_texto.equals("")) {
            lbErro!!.style.display = "none"
        } else {
            lbErro!!.addClass(sClasse)
            lbErro!!.innerText = _texto
            lbErro!!.style.display = "block"
            if (_audio)
                ffAudio().ffPlayBeep(false)
        }
    }
}

fun ffValidar(_it: String, _tipoCampo: String, _maxLenght: Int, _maxValor: Int = 0): String {

    println0("ffValidar tipoCampo $_tipoCampo ${_tipoCampo!!.ffCopy(1, 2)} $_it")

    var s: String = _it.toString()
    if (_maxLenght != 0)
        s = s.ffCopy(0, _maxLenght + s.ffCarac(".,"))
    if (_tipoCampo.equals("N") && _maxValor > 0 && s.ffVsi() > _maxValor)
        s = _maxValor.toString()

    if (_tipoCampo != null) {
        if (_tipoCampo.equals("D2") || _tipoCampo.equals("D4")) {
            s = s.replace("/", "").replace("-", "").replace(" ", "")
            if (s.ffCopy(5, 4).trim().length == 2)
                s = s.ffCopy(1, 2) + "/" + s.ffCopy(3, 2) + "/20" + s.ffCopy(5, 2)
            else
                s = s.ffCopy(1, 2) + "/" + s.ffCopy(3, 2) + "/" + s.ffCopy(5, 4)
            //println0(s)
            if (_tipoCampo.equals("D4"))
                s = s.ffDsd().ffDdBr(4)
            else
                s = s.ffDsd().ffDdBr(2)
            //s = s.replace("/","-")
        } else if (_tipoCampo.equals("S")) {


            //if (_tipoCampo!!.ffCopy(1, 1).equals("N")) {
        } else if (!_tipoCampo!!.ffCopy(1, 2).equals("NS")) {
            //println("zuza chegou na validação do campo numérico com $s")
            s = s.ffNumero()
            if (s.contains("-") && s.indexOf("-") > 0)
                s = s.replace("-", "")

            //println0("zuzalig00 $s")

            if (!s.equals("")) {
                if (_tipoCampo.length == 1) {
                    s = s.ffVsRel(9)
                } else {
                    val iDig = _tipoCampo.ffSoNumero().ffVsi()
                    s = s.ffVsRel(iDig)
                }
            }
        }
        //println("zuza chegou na validação do campo numérico retornando $s")
    }
    return s
}

fun getRelatorio(iRelatorio: Int = 0, sParams: String, _link: Boolean = false) {
    var sUrl = ""

    when (iRelatorio) {
        14 -> sUrl = "|0${ff.gsDom1}/relatorio/014/" +
                "${ff.giEmpresa}/${ff.goFUNCIONARIO.ID_FUNCIONARIO}/" +
                "${ff.ffPegaCampo(sParams, "|sDtIni")}/${ff.ffPegaCampo(sParams, "|sDtFim")}/" +
                "0/0/token=${ff.gsToken}/" +
                "_corte014_rel" //nome do relatório
        15 -> sUrl = "|0${ff.gsDom1}/relatorio/015/" +
                "${ff.giEmpresa}/${ff.goFUNCIONARIO.ID_FUNCIONARIO}/" +
                "${ff.ffPegaCampo(sParams, "|sDtIni")}/${ff.ffPegaCampo(sParams, "|sDtFim")}/" +
                "0/${ff.ffPegaCampo(sParams, "|sTipoNota")}/${ff.ffPegaCampo(sParams, "|sTipoData")}/" +
                "token=${ff.gsToken}/" +
                "_notas_terminadas015_rel" //nome do relatório
        16 -> sUrl = "|0${ff.gsDom1}/relatorio/016/" +
                "${ff.giEmpresa}/${ff.goFUNCIONARIO.ID_FUNCIONARIO}/" +
                "0/${ff.ffPegaCampo(sParams, "|sDtIni")}/token=${ff.gsToken}/" +
                "_oportunidades016_rel" //nome do relatório
        else -> sUrl = ""
    }

    if ((!_link) && (iRelatorio > 0)) {
        ff.ffUrlAbrir(ff.ffPegaCampo(sUrl, "|0"), true)
    }

    if (_link) {
        ff.println0("relatorio url ${sUrl}")
    }
}

